import React from 'react';
import { Route } from 'react-router';
import OmniSearchResponsive from '@app/components/presentational/OmniSearchResponsive';
import OverlayLoader from '../components/containers/OverlayLoader';
import UserBar from '../components/presentational/Navigation/UserBarToggle';
import { getCurrentUser } from '@core/utils/currentUser';
import { fetchInitialData } from './Dashboard';

const getOnSearchEnter = (queryClient) => async (nextState, replace) => {
  if (!getCurrentUser()) {
    replace({
      pathname: '/logout',
      state: { nextPathname: nextState.location.pathname },
    });
    return;
  }
  await fetchInitialData(queryClient);
};

const SearchRoute = (queryClient) => {
  return (
    <Route
      path="search"
      components={{
        overlayLoader: OverlayLoader,
        userBar: UserBar,
        content: OmniSearchResponsive,
      }}
      onEnter={getOnSearchEnter(queryClient)}
    />
  );
};

export default SearchRoute;
